// extracted by mini-css-extract-plugin
module.exports = {"Register":"Register_Register__28yeG","message":"Register_message__Ec1yA"};